import { render, staticRenderFns } from "./ClaimExamList.vue?vue&type=template&id=725ad391&"
import script from "./ClaimExamList.vue?vue&type=script&lang=js&"
export * from "./ClaimExamList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports